import { Arrow } from "../styled";
import { ReactComponent as ArrowSvg } from "../assets/arrow.svg";

export function PrevArrow(props) {
  const { className, style, onClick, currentSlide } = props;

  if (currentSlide === 0) return <></>;

  return (
    <Arrow
      onClick={onClick}
      className={className}
      style={{ ...style, left: "-3%", top: "35%" }}
    >
      <ArrowSvg style={{ transform: "rotate(180deg)" }} />
    </Arrow>
  );
}
